<script lang="ts" setup>
import IconPen from '@/shared/icons/IconPen.vue';
import { goAssinatura } from '@/shared/utils/routeNavigate';
</script>

<template>
  <div class="card buttonTakeSignature" role="button" @click="goAssinatura()">
    <span>Assinar</span>
    <IconPen />
  </div>
</template>

<style lang="scss">
.buttonTakeSignature {
  cursor: pointer;
  margin-top: 0.8rem;
  padding: 1rem;
  display: flex;
  flex-direction: row !important;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  color: var(--primary);

  svg {
    display: block;
    width: 2rem;
    height: 2rem;
  }
}
</style>
